var render, staticRenderFns
import script from "./comp_dpc-CarouselMultiple.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-CarouselMultiple.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-CarouselMultiple.vue?vue&type=style&index=0&id=443056a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443056a6",
  null
  
)

export default component.exports